import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import './App.css';
import MainMenu from './components/MainMenu'
import CreatePassword from './components/CreatePassword';
import ForgetPassword from './components/ForgetPassword';
import ForgetPasswordChangePW from './components/ForgetPasswordChangePW';
import Login from './components/Login';
import PdfReport from './components/PdfReport';
import Register from './components/Register';
import ResultList from './components/ResultList'
import ResultSummary from './components/ResultSummary'
import TermAndCondition from './components/TermAndCondition';

class App extends Component {
  render() {
    return (
      <div className="App">
        <Route path="/" exact component={Login}/>
        <Route path="/createPassword" component={CreatePassword}/>
        <Route path="/forgetPassword" component={ForgetPassword}/>
        <Route path="/forgetPasswordChangePW" component={ForgetPasswordChangePW}/>
        <Route path="/login" component={Login}/>
        <Route path="/pdfReport" component={PdfReport}/>
        <Route path="/register" component={Register}/>
        <Route path="/resultlist" component={ResultList}/>
        <Route path="/resultsummary" component={ResultSummary}/>
        <Route path="/term" component={TermAndCondition}/>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js